import useTranslator from "../../hooks/useTranslator";
import { Card } from "../design";
import "./TotalSalaryModal.css";

const SalaryCard = ({ effortObj = {} }) => {
  const { _t } = useTranslator();
  return (
    <Card as="div" className="totalSalaryDrawer__salary">
      <span className="totalSalaryDrawer__salaryLabel">{_t("total")}</span>
      <span className="totalSalaryDrawer__salaryValue">
        €{effortObj?.monthly_sal}
      </span>
    </Card>
  );
};

export default SalaryCard;
